
    import { computed, defineComponent } from 'vue';
    import { DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-vue-buttons';
    import { useUserStore } from '@/store/user'

    export default defineComponent({
        name: 'LanguageSelector',

        components: {
            DropDownButton
        },

        setup() {
            const userStore = useUserStore();

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const dataItems = [
                {
                    languageCode: 'E',
                    title: 'English',
                    language: 'uk'
                },
                {
                    languageCode: 'D',
                    title: 'Deutsch',
                    language: 'de'
                },
                {
                    languageCode: 'K',
                    title: 'Dansk',
                    language: 'dk'
                },
                {
                    languageCode: 'V',
                    title: 'Svenska',
                    language: 'se'
                }
            ];

            const publicData = { dataItems }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const selectedItem = computed(() => dataItems.find(item => item.languageCode === userStore.language) ?? dataItems[0]);
            const selectedLanguage = computed(() => selectedItem.value.language)
            const iconPathSelectedLanguage = computed(() => iconPath(selectedLanguage.value))

            const computedData = { selectedItem, selectedLanguage, iconPathSelectedLanguage  }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function iconPath(language: string) {
                return require(`@/img/icon-flag-${language}.svg`);
            }

            function onLanguageSelect(e: DropDownButtonItemClickEvent) {
                SetLanguage(e.item.languageCode)
            }

            const publicMethods = { iconPath, onLanguageSelect }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function SetLanguage(languageCode: string) {
                userStore.setLanguage(languageCode);
            }

            return { ...publicData, ...computedData, ...publicMethods };
        }
    });
